const getFilteredDefinitionValues = (definition, searchTerm) => {
  const normalizedSearchTerm = searchTerm.trim().toLowerCase();
  if (!normalizedSearchTerm) {
    return definition.values || [];
  }

  const directMatches = (definition.values || []).filter(value =>
    value.text.toLowerCase().includes(normalizedSearchTerm),
  );
  const hasHierarchy = definition.values?.some(value =>
    value.hierarchyAncestorValues || value.hierarchyBranchValues,
  );
  if (!hasHierarchy) {
    return directMatches;
  }

  const visibleValues = new Set(directMatches.map(value => value.value));
  directMatches.forEach(value => {
    value.hierarchyAncestorValues?.forEach(ancestorValue => visibleValues.add(ancestorValue));
    value.hierarchyBranchValues?.forEach(branchValue => visibleValues.add(branchValue));
  });

  return definition.values.filter(value => visibleValues.has(value.value));
};

export default getFilteredDefinitionValues;
